<template>
  <div id="app" :class="[{'menu-opened': $root.menuOpen, 'submenu-opened': $root.subMenuOpen, 'belowhero': $root.belowHero, 'share-opened': $root.shareOpen}]">
    <PageHeader />
    <SiteNavigation />
    <main class="page-container" :class="{'page-container--home': $route.name === 'Homepage'}">
      <transition appear mode="out-in" :css="false" v-on:enter="enter" v-on:leave="leave">
        <router-view/>
      </transition>
      <Footer />
    </main>
  </div>
</template>

<script>
import { TimelineMax } from 'gsap'

import LanguageSelector from '@/components/LanguageSelector'
import PageHeader from '@/components/PageHeader'
import SiteNavigation from '@/components/SiteNavigation'
import Footer from '@/components/Footer'

export default {
  name: 'App',
  components: {
    LanguageSelector,
    PageHeader,
    SiteNavigation,
    Footer
  },
  data () {
    return {
      transitionName: 'fade'
    }
  },
  methods: {
    enter (el, done) {
      var tl = new TimelineMax({onComplete: done})
      // tl.set(el, {x: window.innerWidth * 1.5, scale: 0.8, transformOrigin: '50% 50%'})
      tl.from(el, 0.4, {autoAlpha: 0, ease: Power4.easeOut})
      // tl.to(el, 1, {scale: 1, ease: Power4.easeOut})
    },
    leave (el, done) {
      // console.log($event)
      // var test = document.querySelector('.test')
      // var revealer = $('.green-transition')
      // var tl = new TimelineMax({onComplete: done})

      TweenMax.fromTo(el, 0.4, {
        autoAlpha: 1
      }, {
        autoAlpha: 0,
        ease: Power4.easeOut,
        onComplete: done
      })
      // tl.to(el, 0.45, {autoAlpha: 0, ease: Power1.easeOut, onComplete: done})
    }
  }
}
</script>

<style lang="scss">
@import './scss/grid';
@import '~normalize-scss/sass/normalize';
@import './scss/layout';
@import './scss/typography';
*, *:before, *:after {
  box-sizing: border-box;
}
html, body {
  margin: 0;
  color: $darker-grey;
  font-family: $font-primary;
  font-size: 15px;
  background: #f2f4f5;
}
body.modalOpen {
  overflow: hidden;
}
#app {
  .page-container {
    position: relative;
  }
  &.menu-opened {
    .page-container.page-container--home {
      @media(min-width: $screen-sm-min) {
        padding-left: $sidenav-width; // Only pushes the page over on home
      }
    }
  }
  .page-container.page-container--home {
    transition: .4s padding-left;
  }
  .img-responsive {
    width: 100%;
    height: auto;
  }
  .bg-green {
    background-color: $green-light;
  }
  .bg-darkgrey {
    background-color: $dark-grey;
  }
  .bg-darkergrey {
    background-color: $darker-grey;
  }
  .c-grey {
    color: $grey;
  }
  .c-palegrey {
    color: $pale-grey;
  }
  .c-lightgreen {
    color: $green-light;
  }
  section {
    // margin: 110px 0;
    @media(min-width: $screen-sm-min) {
      // margin: 120px 0;
    }
  }
  hr {
    height: 2px;
    background-color: #e7e6e6;
    border: none;
    margin-top: 0;
    margin-bottom: 0;
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .cta-button-route {
    display: inline-block;
    background: $blue;
    color: $white;
    padding: 16px 24px;
    text-decoration: none;
    cursor: pointer;
    &:hover {
      box-shadow: 0px 6px 16px 0px rgba(0,0,0,.07);
    }
    &:active {
      color: #2c7899;
      box-shadow: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue